// @flow

import { type Theme } from './types';

export function fakeTheme(override?: ($Shape<Theme>) => Theme): Theme {
  const theme = {
    button: {
      rounded: true,
      fontFamily: 'sansSerif',
      fontWeight: '400',
    },
    fontFamily: {
      sansSerif: '"Open Sans", "OpenSans", "Helvetica Neue", Helvetica, Arial, sans-serif',
      display: '"Gilroy", "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica, sans-serif',
    },
    fontSize: '14px',
    colors: {
      black: 'hsl(218, 44%, 32%)',
      green: l => `hsl(89, 46%, ${l}%)`,
      gray: l => `hsl(240, 14%, ${l}%)`,
      primary: l => `hsl(201, 72%, ${l}%)`,
      secondary: l => `hsl(217, 41%, ${l}%)`,
      warning: l => `hsl(57, 93%, ${l}%)`,
      error: l => `hsl(8, 56%, ${l}%)`,
      info: l => `hsl(201°, 70%, ${l}%)`,
      new_primary: {
        [50]: '#E5EEFF',
        [100]: '#CCDCFF',
        [300]: '#6697FF',
        [500]: '#0051FF',
        [600]: '#0040CA',
        [700]: '#003199',
      },
      neutral: {
        white: '#FFFFFF',
        [100]: '#F1F3F6',
        [150]: '#E6E9EF',
        [200]: '#D4D9E3',
        [300]: '#AFB8CA',
        [400]: '#8B97B1',
        [500]: '#6C7993',
        [600]: '#515A6C',
        [700]: '#333947',
        [900]: '#121419',
      },
      feedback: {
        positive: {
          [100]: '#E4F6E8',
          [200]: '#B4E4BE',
          [500]: '#20A83E',
          [600]: '#1A8632',
        },
        warning: {
          [100]: '#FFF0DB',
          [200]: '#FFD599',
          [500]: '#FF9500',
          [600]: '#CC7700',
          [900]: '#804A00',
        },
        error: {
          [100]: '#FAE8EA',
          [200]: '#F1BBC1',
          [500]: '#D21E32',
          [600]: '#A81828',
        },
      },
    },
    layout: {
      bordered: false,
      raised: true,
      hideEbanxHeader: false,
      hideMerchantLogo: false,
    },
    radius: '8px',
  };

  return {
    ...theme,
    ...(override ? override(theme) : null),
  };
}
